<div *ngIf="activeStatus;else empty"> {{activeStatus.name}}</div>
<ng-template #empty>-</ng-template>

